var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "tournamentList" } } },
                    [_vm._v(_vm._s(_vm.$t("entities.tournament.plural")))]
                  ),
                  _vm._v(" "),
                  _vm.editing && _vm.model
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "tournamentShow",
                              params: { id: _vm.model.id }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.model.name))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.edit")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.add")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") +
                            " " +
                            _vm.$t("entities.tournament.singular")
                        : _vm.$t("table.add") +
                            " " +
                            _vm.$t("entities.tournament.singular")
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name", prop: "name" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Locality", prop: "locality" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.locality,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "locality", $$v)
                                  },
                                  expression: "model.locality"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Country", prop: "country" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.country,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "country", $$v)
                                  },
                                  expression: "model.country"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Web", prop: "web" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.web,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "web", $$v)
                                  },
                                  expression: "model.web"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("\n          Save\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5444a14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5444a14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/tournament/tournament-form.vue
// module id = null
// module chunks = 